import $ from 'jquery';

(function () {

  const $body = $('body');

  const exports = {

    attachToggle: function () {
      $('[data-navigation-panel-toggle]').on('click', function (event) {
        event.preventDefault();
        if ($body.hasClass('body--navigation-panel-visible')) {
          $body.removeClass('body--navigation-panel-visible');
        } else {
          $body.addClass('body--navigation-panel-visible');
        }
      });
    },

    initialize: function () {

      exports.attachToggle();

    }

  };

  exports.initialize();

})();
